<template>
    <div class="c-a-textarea">
        <label class="c-a-textarea__label" :for="`textarea-${id}`">{{label}}</label>
        <p class="c-a-textarea__info">{{info}}</p>
        <textarea
            :id="`textarea-${id}`"
            :name="`textarea-${id}`"
            @input="updated"
            :value="value"
            class="c-a-textarea__textarea"
            :placeholder="placeholder"
            :rows="rows"
        ></textarea>
    </div>
</template>

<script>
    export default {
        props:{
            id: Number|String,
            info: String,
            icon: String,
            label: String,
            value: String,
            placeholder: String,
            rows: {
                type: Number,
                default: 6
            }
        },
        methods:{
            updated(event){
                this.$emit('input', event.target.value);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/form/AtomTextarea.vue